<div
  class="tiime-icon-container"
  tiimeTooltip
  tooltipClass="tiime-tooltip"
  [tooltipPosition]="tooltipPosition"
  [tooltipContent]="tagsTooltipTemplate"
>
  <app-tag-icon [tags]="tags" />
</div>
<ng-template #tagsTooltipTemplate>
  <div class="tiime-tooltip-content">
    @for (tag of tags; track trackByIndex($index)) {
      <div>{{ tag }}</div>
    }
  </div>
</ng-template>
